import { FileClock, X } from "lucide-react";
import { fmtDate } from "@/lib/api";

export const DraftBanner = ({ draft, onResume, onDiscard }) => (
  <div className="flex flex-col sm:flex-row sm:items-center gap-3 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 fade-up" data-testid="reg-draft-banner">
    <FileClock className="w-5 h-5 text-amber-600 shrink-0" />
    <div className="flex-1 text-sm">You have a saved registration draft from <strong>{fmtDate(draft.updated_at)}</strong>. Continue where you left off?</div>
    <div className="flex gap-2">
      <button onClick={onResume} className="h-9 px-4 rounded-md bg-[#111] hover:bg-[#262626] text-white text-sm font-semibold" data-testid="reg-draft-resume-button">Resume draft</button>
      <button onClick={onDiscard} className="h-9 px-3 rounded-md border border-gray-300 text-sm hover:border-[#E60000] hover:text-[#E60000] inline-flex items-center gap-1" data-testid="reg-draft-discard-button"><X className="w-4 h-4" />Discard</button>
    </div>
  </div>
);
